import React from "react";
import ReactApexChart from "react-apexcharts";
import moment from "moment";
import axios from "axios";

const StackedBarChart = (props) => {
  const {
    filterBy,
    setfilterBy,
    setselectedDate,
    data,
    autoselectedDate,
    fixedData,
    ChartNo,
    utcToTimeZone,
  } = props;

  const labelsExist = data && data.length > 0 && data[0].label !== undefined;

  const tickAmounts =
    filterBy === "hourly"
      ? 12
      : filterBy === "daily"
      ? 24
      : filterBy === "weekly" && 7;
  const firstTime = autoselectedDate;
  // const firstTime = moment(autoselectedDate).subtract(5, 'hours');


  const xCategories = [];
  if (labelsExist) {
    var uniqueLabels = [...new Set(data.map((item) => item.label))];
  } else {
    var uniqueLabels = labelsExist
      ? [...new Set(data.map((item) => item.label))]
      : ["Inhaler Count"];
  }
  const countsByLabel = {};

  uniqueLabels.forEach((label) => {
    countsByLabel[label] = [];
  });

  for (let i = 0; i < tickAmounts; i++) {
    const hourTime = moment(firstTime).add(i, "hours").format("HH:mm");
    const mintTime = moment(firstTime)
      .add(i * 5, "minutes")
      .format("HH:mm");
    const weekTime = moment(firstTime).add(i, "days").format("MMM D | ddd");
    const formattedHour =
      filterBy === "hourly"
        ? mintTime
        : filterBy === "daily"
        ? hourTime
        : filterBy === "weekly" && weekTime;

    const filteredData = data.filter((item) =>
      moment(utcToTimeZone(item.time_interval))
        .format(
          filterBy === "hourly"
            ? "HH:mm"
            : filterBy === "daily"
            ? "HH:mm"
            : filterBy === "weekly"
            ? "MMM D | ddd"
            : ""
        )
        .includes(formattedHour)
    );

    xCategories.push(formattedHour);

    uniqueLabels.forEach((label) => {
      const labelCount = filteredData
        .filter((item) => item.label === label)
        .reduce((total, item) => total + item.count, 0);

      countsByLabel[label].push(labelCount);
    });
  }

  const series = uniqueLabels.map((label) => ({
    name: label == "low" ? "Cough Count" : label == "high" ? "High" : label,
    data: countsByLabel[label],
    color: "#38B6FF",
  }));

  const handleDataPointSelection = (dataPointIndex) => {
    if (filterBy === "weekly") {
      setselectedDate(
        fixedData.find(
          (item) =>
            moment(item.time_interval).format("MMM D | ddd") ===
            xCategories[dataPointIndex]
        ).time_interval
      );
      setfilterBy("daily");
    } else if (filterBy === "daily") {
      setselectedDate(
        fixedData.filter((item) =>
          item.time_interval.includes(xCategories[dataPointIndex])
        )[0].time_interval
      );
      setfilterBy("hourly");
    } else {
    }
  };

  const options = {
    chart: {
      type: "bar",
      height: 450,
      stacked: true,
      events: {
        dataPointSelection: (event, chartContext, config, xCategories) => {
          handleDataPointSelection(config.dataPointIndex, xCategories);
        },
      },
      toolbar: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 0,
              columnWidth: "10",
            },
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 3,
        columnWidth: "20",
        borderRadiusWhenStacked: "all",
      },
    },
    xaxis: {
      categories: xCategories,
      title: {
        text:
          filterBy == "hourly"
            ? `${moment(autoselectedDate).format("MMM DD, YYYY  HH:mm a")}`
            : filterBy == "daily"
            ? `${moment(autoselectedDate).format("MMM DD ,YYYY")}`
            : `Week ${
                moment(autoselectedDate, "YYYY-MM-DD").week() -
                moment(autoselectedDate, "YYYY-MM-DD").startOf("month").week() +
                1
              } of ${moment(autoselectedDate).format("MMM, YYYY")}`,
        style: {
          // color: "#01CFCE",
          fontSize: "16px",
          fontFamily: "Roboto",
          fontWeight: 600,
          letterSpacing: "0.1px",
        },
      },
    },
    yaxis: {
      title: {
        text: "No. of Coughs",
        style: {
          // color: "#01CFCE",
          fontSize: "16px",
          fontFamily: "Roboto",
          fontWeight: 600,
          letterSpacing: "0.1px",
        },
      },
    },
    legend: {
      position: "top",
      showForSingleSeries: false,
      horizontalAlign: "right",
      markers: {
        radius: 10,
        offsetY: 2,
        width: 33,
      },
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <div id="chart" data-tut={ChartNo === 1 ? "intensity-plots" : "type-plots"}>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default StackedBarChart;
